// Shared tone palette + option helpers for MovingMyMama modules
export const TONE = {
  red: { bg: "rgba(156,30,34,0.10)", color: "#9C1E22", border: "rgba(156,30,34,0.24)" },
  amber: { bg: "rgba(183,121,31,0.14)", color: "#9A6516", border: "rgba(183,121,31,0.30)" },
  sky: { bg: "rgba(155,185,206,0.25)", color: "#1C4358", border: "rgba(155,185,206,0.45)" },
  navy: { bg: "rgba(28,67,88,0.10)", color: "#1C4358", border: "rgba(28,67,88,0.20)" },
  green: { bg: "rgba(47,125,90,0.12)", color: "#256B4B", border: "rgba(47,125,90,0.28)" },
  khaki: { bg: "rgba(196,200,155,0.35)", color: "#5A5E2E", border: "rgba(196,200,155,0.60)" },
  gray: { bg: "rgba(75,85,99,0.10)", color: "#4B5563", border: "rgba(75,85,99,0.22)" },
};

export const prettify = (v) =>
  v ? String(v).replace(/_/g, " ").replace(/\b\w/g, (c) => c.toUpperCase()) : "";
export const optOf = (arr, val) => arr.find((o) => o.value === val) || null;
export const labelOf = (arr, val) => optOf(arr, val)?.label || prettify(val);
export const toneOf = (arr, val) => TONE[optOf(arr, val)?.tone || "gray"];
